<template>
  <div class="suggestion-item">
    <font-icon class="icon-hotelux suggestion-item-icon" :icon="iconName" />
    <UIText type="bold" class="suggestion-item-label">
      {{ label }}
    </UIText>
  </div>
</template>

<script setup>
import { computed } from "vue";

import UIText from "../UiText/index.vue";

const props = defineProps({
  item: { type: Object, required: true }
});

// 联想类型对应设计稿的图标
const iconMaps = {
  googleMapPolitical: "icon-hotelux-Location",
  city: "icon-hotelux-Location",
  moduleTpHotel: "icon-hotelux-Hotel-copy",
  search: "icon-hotelux-Search"
};

const iconName = computed(() => iconMaps[props.item.locationType]);

const subLabel = computed(() =>
  props.item.showHotelEnName ? props.item.nameEn : ""
);

const label = computed(() =>
  subLabel.value
    ? `${props.item.showLabel}, ${subLabel.value}`
    : props.item.showLabel
);

defineOptions({
  name: "HoteluxSuggestionItem"
});
</script>

<style lang="scss" scoped>
.suggestion-item {
  display: flex;
  align-items: center;
  height: 72px;
}

.suggestion-item-icon {
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  font-size: 26px;
  line-height: 1;
  color: #2a2c35;
  background: #f8f8f8;
}

.suggestion-item-label {
  flex: 1;
  min-width: 0;
  margin-left: 12px;
  overflow: hidden;
  // font-family: "lato-bold";
  font-size: 16px;
  line-height: 18px;
  color: #212223;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style lang="scss">
// 下拉面板由 el-autocomplete teleport 到 body 上，scoped 选择器命中不到，
// 因此这里不加 scoped，统一以 popper-class .hotelux-location-popper 作为锚点
.hotelux-location-popper {
  // 弹层挂在搜索栏容器上，popper 计算出的 top/left 会被下面两条覆盖，
  // 保证弹层始终固定在搜索栏下方（不会因下方空间不足翻到上方），且与搜索栏左边缘对齐。
  // 17px = 16px 间距 + 搜索栏 1px 下描边
  top: calc(100% + 17px) !important;
  right: auto !important;
  bottom: auto !important;
  left: 0 !important;
  // 设计稿外框 440 宽
  width: 440px;
  min-width: 440px;
  margin: 0;
  border: 1px solid #dadada;
  border-radius: 0;
  box-shadow: 0 6px 24px rgb(0 0 0 / 12%);

  .el-popper__arrow {
    display: none;
  }

  // 设计稿内容区左右各留 40、上下各留 32
  .el-autocomplete-suggestion {
    padding: 32px 40px;
    border-radius: 0;
  }

  .el-autocomplete-suggestion__wrap {
    max-height: 472px;
    padding: 0;
  }

  .el-autocomplete-suggestion__list {
    margin: 0;
    padding: 0;
  }

  // 设计稿不展示滚动条
  .el-scrollbar__bar {
    display: none;
  }

  li {
    padding: 0;
    line-height: 1;
    background-color: transparent;

    &:hover,
    &.highlighted {
      background-color: #f8f8f8;
    }
  }
}

// 吸顶态下拉窗（设计稿 360x505）：面板收窄，行高 52、图标 32、文案 14px
.hotelux-search-bar.sticky .hotelux-location-popper {
  width: 360px;
  min-width: 360px;
  border: 0;
  box-shadow: 0 2px 18px rgb(0 0 0 / 8%);

  // 设计稿内容区左右各留 24、上留 24、下留 10
  .el-autocomplete-suggestion {
    padding: 24px 24px 10px;
  }

  .suggestion-item {
    height: 52px;
  }

  // 设计稿首行「按关键词搜索」项比普通联想项高 4px
  li:first-child .suggestion-item {
    height: 56px;
  }

  .suggestion-item-icon {
    width: 32px;
    height: 32px;
    font-size: 15px;
  }

  .suggestion-item-label {
    font-size: 14px;
    line-height: 16px;
  }
}
</style>
